const config = {
  configEndpoints: {
    baseEndpoint: "https://api.dev.hub.affinity.io/partner",
  },
};
export default config;
